shadow$provide[365] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform vec4 clampLimit;

vec4 getClampXYZW(vec4 xyzw) {
  return clamp(xyzw, vec4(0.0), clampLimit);
}
`;

};